import { useTranslation } from "react-i18next";
import { Button, CloseIcon, IconButton, RefreshIcon } from "../ui/index.js";
import { dismissBanner, reloadByUser, useUpdateBanner } from "./update.js";

/**
 * Плашка «Доступна новая версия»: показывается, пока новая версия ждёт перезагрузки на переходе (`update.ts`);
 * «Скрыть» прячет её до пропущенного перехода. Сверху под вырезом экрана, чтобы не закрывать кнопки внизу форм
 * («Сохранить»). Текст просит сохранить правки: на iOS Safari предупреждения `beforeunload` нет.
 */
export function UpdateBanner() {
  const { t } = useTranslation();
  const show = useUpdateBanner();
  if (!show) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 top-[calc(env(safe-area-inset-top)+0.5rem)] z-30 mx-auto flex w-[calc(100%-2rem)] max-w-md items-center gap-3 rounded-card border border-line bg-white px-4 py-3 text-sm text-ink shadow-pop lg:top-4"
    >
      <RefreshIcon className="h-5 w-5 shrink-0 text-brand" />
      <span className="flex-1">{t("update.available")}</span>
      <Button size="sm" onClick={reloadByUser}>
        {t("update.reload")}
      </Button>
      <IconButton size="sm" label={t("update.dismiss")} icon={<CloseIcon />} onClick={dismissBanner} className="-mr-2" />
    </div>
  );
}
